import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useAppContext } from "../helpers/useAppContext";
import styles from "./CookieSettings.module.css";
import { Checkbox } from "../finder/Checkbox";
import { Button } from "./Button";

export const CookieSettings = () => {
  const { cookies } = useAppContext();
  const router = useRouter();
  const {
    advertising,
    analytics,
    functional,
    setAdvertising,
    setAnalytics,
    setAccepted,
  } = cookies;
  const [tmpAdvertising, setTmpAdvertising] = useState(advertising);
  const [tmpAnalytics, setTmpAnalytics] = useState(analytics);

  function onAdvertisingChange(e: any) {
    setTmpAdvertising(e.target.checked ? 1 : 0);
  }

  function onAnalyticsChange(e: any) {
    // setTmpAnalytics(e.target.checked ? 1 : 0);
    setTmpAnalytics(1);
  }

  function save() {
    setAdvertising(tmpAdvertising ? 1 : 0);
    // setAnalytics(tmpAnalytics ? 1 : 0);
    setAnalytics(1);
    setAccepted(1);
    if (router.query?.redirect) {
      router.back();
    } else {
      router.push("/");
    }
  }

  function reset() {
    setAccepted(0);
    setAdvertising(0);
    setAnalytics(1);
    if (router.query?.redirect) router.back();
  }

  useEffect(() => {
    // setTmpAnalytics(analytics);
    setTmpAdvertising(advertising);
  }, [advertising, analytics]);

  return (
    <div className={styles.container}>
      <Checkbox
        disabled
        wrap
        checked={functional}
        name="functional"
        label="Functioneel: cookies die ervoor zorgen dat de site naar behoren werkt."
        value="functional"
      />
      <Checkbox
        disabled
        wrap
        // checked={tmpAnalytics}
        checked={true}
        value={tmpAnalytics}
        name="analytics"
        label="Analytics: cookies waarmee we het gebruik van de site kunnen meten. Deze gegevens worden anoniem verzameld voor statistische analyse."
        onChange={onAnalyticsChange}
      />
      <Checkbox
        wrap
        checked={tmpAdvertising}
        value={tmpAdvertising}
        name="advertising"
        label="Social Media: cookies die ervoor zorgen dat bezoekers content van social medianetwerken als YouTube kunnen bekijken op deze website. Deze social medianetwerken kunnen bezoekers mogelijk volgen en hun internetgedrag monitoren voor eigen doeleinden."
        onChange={onAdvertisingChange}
      />
      <div className={styles.buttons}>
        <Button onClick={save}>Opslaan</Button>
        <Button onClick={reset} variation="secondary">
          Cookie instellingen verwijderen
        </Button>
      </div>
    </div>
  );
};
